/* Ship to home */
const ADD_SHIPPING_ADDRESS = 'ADD_SHIPPING_ADDRESS';
const CANCEL_ADD_EDIT_SHIPPING_ADDRESS = 'CANCEL_ADD_EDIT_SHIPPING_ADDRESS';
const CHANGE_SHIPPING_ADDRESS = 'CHANGE_SHIPPING_ADDRESS';
const CHANGE_SHIPPING_ADDRESS_ON_CANCEL = 'NEW_CHANGE_SHIPPING_ADDRESS_ON_CANCEL';
const CHANGE_SHIPPING_ADDRESS_REQUEST = 'CHANGE_SHIPPING_ADDRESS_REQUEST';
const CHANGE_SHIPPING_ADDRESS_UI = 'CHANGE_SHIPPING_ADDRESS_UI';
const DELETE_SHIPPING_ADDRESS_FROM_PROFILE = 'DELETE_SHIPPING_ADDRESS_FROM_PROFILE';
const EDIT_BILLING_ADDRESS = 'EDIT_BILLING_ADDRESS';
const EDIT_SHIPPING_ADDRESS = 'EDIT_SHIPPING_ADDRESS';
const FETCH_CITY_STATE_BY_ZIP = 'FETCH_CITY_STATE_BY_ZIP';
const INIT_NEW_SHIPPING_SECTION = 'INIT_NEW_SHIPPING_SECTION';
const INIT_SHIP_TO_HOME_SECTION_UI = 'INIT_SHIP_TO_HOME_SECTION_UI';
const REMOVE_RESTRICTED_ITEMS = 'REMOVE_RESTRICTED_ITEMS';
const SET_EXPRESS_CHECKOUT_ADDRESS = 'SET_EXPRESS_CHECKOUT_ADDRESS';
const SET_NEW_SHIPPING_ADDRESS_STAND_NOT_REQUIRED = 'SET_NEW_SHIPPING_ADDRESS_STAND_NOT_REQUIRED';
const SET_NEW_SHIPPING_GOOGLE_ADDRESS_STAND_NOT_REQUIRED =
    'SET_NEW_SHIPPING_GOOGLE_ADDRESS_STAND_NOT_REQUIRED';
const SET_STREET_ADDRESS_CHECK_EXECUTED = 'SET_STREET_ADDRESS_CHECK_EXECUTED';
const SHOW_ALL_SHIPPING_ADDRESSES = 'SHOW_ALL_SHIPPING_ADDRESSES';
const SHOW_DELETE_SHIPPING_ADDRESS_WARNING = 'SHOW_DELETE_SHIPPING_ADDRESS_WARNING';
const SUBMIT_NEW_SHIPPING_ADDRESS_FORM = 'SUBMIT_NEW_SHIPPING_ADDRESS_FORM';
const SUBMIT_SHIPPING_SECTION = 'SUBMIT_SHIPPING_SECTION';
const SUBMIT_STH_SHIPPING_SELECTION = 'SUBMIT_STH_SHIPPING_SELECTION';
const UPDATE_SELECTED_ADDRESS = 'UPDATE_SELECTED_ADDRESS';
const UPDATE_SHIPPING_ADDRESS_FIELD_ERROR = 'UPDATE_SHIPPING_ADDRESS_FIELD_ERROR';
const UPDATE_SHIPPING_ADDRESS_FORM = 'UPDATE_SHIPPING_ADDRESS_FORM';
const UPDATE_SHIPPING_ADDRESS_FORM_ERROR = 'UPDATE_SHIPPING_ADDRESS_FORM_ERROR';
const UPDATE_SHIPPING_METHOD = 'UPDATE_SHIPPING_METHOD';
const UPDATE_SHIPPING_TYPE = 'UPDATE_SHIPPING_TYPE';

/* Ship to store */
const CHANGE_STORE_UPDATE_UI = 'CHANGE_STORE_UPDATE_UI';
const CHANGE_STS_UPDATE_UI = 'CHANGE_STS_UPDATE_UI';
const CLEAR_USER_INPUT_ADDRESS = 'CLEAR_USER_INPUT_ADDRESS';
const NEW_ADD_STORE_TO_PROFILE = 'NEW_ADD_STORE_TO_PROFILE';
const NEW_INIT_SHIP_STORE_SECTION_UI = 'NEW_INIT_SHIP_STORE_SECTION_UI';
const PROFILE_ADDED_STORE_UPDATE_UI = 'PROFILE_ADDED_STORE_UPDATE_UI';
const SELECT_STORE_FROM_PROFILE = 'SELECT_STORE_FROM_PROFILE';
const UPDATE_SHIPPING_METHOD_LIST = 'UPDATE_SHIPPING_METHOD_LIST';
const UPDATE_STS__FIELD_ERROR = 'UPDATE_STS__FIELD_ERROR';
const UPDATE_STS__FORM = 'UPDATE_STS__FORM';
const UPDATE_STS__FORM_ERROR = 'UPDATE_STS__FORM_ERROR';
const SET_NEW_SHIPPING_ADDRESS_SUBPREMISE_INVALID = 'SET_NEW_SHIPPING_ADDRESS_SUBPREMISE_INVALID';
const SET_GAV_ERROR = 'SET_GAV_ERROR';
const CLEAR_GAV_ERROR = 'CLEAR_GAV_ERROR';
/* Payment */
// const GET_BNPL_ADDRESS = 'GET_BNPL_ADDRESS';

export {
    ADD_SHIPPING_ADDRESS,
    CANCEL_ADD_EDIT_SHIPPING_ADDRESS,
    CHANGE_SHIPPING_ADDRESS_ON_CANCEL,
    CHANGE_SHIPPING_ADDRESS_REQUEST,
    CHANGE_SHIPPING_ADDRESS_UI,
    CHANGE_SHIPPING_ADDRESS,
    CHANGE_STORE_UPDATE_UI,
    CHANGE_STS_UPDATE_UI,
    CLEAR_USER_INPUT_ADDRESS,
    DELETE_SHIPPING_ADDRESS_FROM_PROFILE,
    EDIT_BILLING_ADDRESS,
    EDIT_SHIPPING_ADDRESS,
    FETCH_CITY_STATE_BY_ZIP,
    INIT_NEW_SHIPPING_SECTION,
    INIT_SHIP_TO_HOME_SECTION_UI,
    NEW_ADD_STORE_TO_PROFILE,
    NEW_INIT_SHIP_STORE_SECTION_UI,
    PROFILE_ADDED_STORE_UPDATE_UI,
    REMOVE_RESTRICTED_ITEMS,
    SELECT_STORE_FROM_PROFILE,
    SET_EXPRESS_CHECKOUT_ADDRESS,
    SET_NEW_SHIPPING_ADDRESS_STAND_NOT_REQUIRED,
    SET_NEW_SHIPPING_GOOGLE_ADDRESS_STAND_NOT_REQUIRED,
    SET_STREET_ADDRESS_CHECK_EXECUTED,
    SHOW_ALL_SHIPPING_ADDRESSES,
    SHOW_DELETE_SHIPPING_ADDRESS_WARNING,
    SUBMIT_NEW_SHIPPING_ADDRESS_FORM,
    SUBMIT_SHIPPING_SECTION,
    SUBMIT_STH_SHIPPING_SELECTION,
    UPDATE_SELECTED_ADDRESS,
    UPDATE_SHIPPING_ADDRESS_FIELD_ERROR,
    UPDATE_SHIPPING_ADDRESS_FORM_ERROR,
    UPDATE_SHIPPING_ADDRESS_FORM,
    UPDATE_SHIPPING_METHOD_LIST,
    UPDATE_SHIPPING_METHOD,
    UPDATE_SHIPPING_TYPE,
    UPDATE_STS__FIELD_ERROR,
    UPDATE_STS__FORM_ERROR,
    UPDATE_STS__FORM,
    SET_NEW_SHIPPING_ADDRESS_SUBPREMISE_INVALID,
    SET_GAV_ERROR,
    CLEAR_GAV_ERROR,
};
